import React, { type ReactNode } from 'react'
import { FormGroup, type FormHelperTextProps } from '@theneatcompany/nui'

interface FieldErrorProps extends FormHelperTextProps {
  label?: ReactNode
  message?: string
  touched?: boolean
  ignoreTouched?: boolean
  onRender?: (label: ReactNode, message: ReactNode) => ReactNode
}

const FieldError = ({
  label,
  message,
  touched = false,
  ignoreTouched = false,
  onRender,
  className,
  ...rest
}: FieldErrorProps) => {
  if (!message) return null
  const defaultMessage = label ? `${label} ${message}` : message
  const errorMessage = onRender ? onRender(label, message) : defaultMessage

  return (touched || ignoreTouched) && (
    <FormGroup.HelperText className={className} role="alert" {...rest}>
      {errorMessage}
    </FormGroup.HelperText>
  )
}

export default FieldError
